export enum RoundPhase {
  initialPhase,
  openRedCard,
  playBlackCard,
  waitForOthersToPlay,
  lookAtPlayedCards,
  roundWinner,
}